import Image from 'next/image';

export function WelcomeToCxMapper() {
  return (
    <div className="cx-login-welcome">
      <Image
        src={'/images/developed_by_itaicx.png'}
        alt="Delevolped by ItaiCX"
        width={140}
        height={140}
      />

      <span className="cx-login-welcome-title mt-10 flex items-center gap-1 text-lg whitespace-nowrap">
        <h1 className="cx-login-welcome-prefix">Seja bem vindo(a) ao</h1>
        <h1 className="cx-login-welcome-brand text-brand-color-green font-semibold">CXMapper</h1>
      </span>
    </div>
  );
}
